import React, { Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Row, Col } from 'reactstrap';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import * as constants from '../config/constants';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const styles = {
	appBar: {
		position: 'relative',
	},
	flex: {
		flex: 1,
	},
	card : {
		width : 'auto',
		hieght : '100%',
	},
	formControl: {	
		minWidth: '100%',
		margin : '0 0 15px 0'
	},
};

function Transition(props) {
	return <Slide direction="up" {...props} />;
}
class WriteAssociate extends Component {
	constructor(props){
		super(props);
		this.state = {
			open : this.props.open,
			closeCB : this.props.closeCB ? this.props.closeCB : null,
			createCB : this.props.createCB ? this.props.createCB : null,
			currentAssociate : this.props.currentAssociate ? this.props.currentAssociate : null,
			name : '',
			email : '',
			department : '',
			id : '',
		}
		this.handleClose = this.handleClose.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.createAssociates = this.createAssociates.bind(this);
		this.editAssociates = this.editAssociates.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		let copiedStates = Object.assign({},this.state);
		copiedStates.open = nextProps.open;
		console.log("nextProps", nextProps);
		if(nextProps.currentAssociate) {
			copiedStates.name = nextProps.currentAssociate.name;
			copiedStates.email = nextProps.currentAssociate.email;
			copiedStates.department = nextProps.currentAssociate.department;
			copiedStates.id = nextProps.currentAssociate.id;
			copiedStates.employeeId = nextProps.currentAssociate.employeeId;
			copiedStates.currentAssociate = nextProps.currentAssociate;
		} else {
			copiedStates.currentAssociate = null;
		}
		copiedStates.open = nextProps.open;
		this.setState(copiedStates);
	}
	componentDidMount(){
	}
	handleClose() {
		let copiedStates = Object.assign({}, this.state);
		copiedStates.open = false;
		copiedStates.closeCB && copiedStates.closeCB();
		this.setState(copiedStates);
	}
	createAssociates() {
		let request={
			name: this.state.name,
			email: this.state.email,
			department: this.state.department,
			employeeId: this.state.employeeId,
		}
		let that = this;
		axios.post( constants.API_BASE_URL + "user",request)
		.then(function (response) {
			that.state.createCB && that.state.createCB(response.data.details);
		})
		.catch(function (error) {
		});
		this.setState({open : false});
	}
	editAssociates() {
		let request={
			name: this.state.name,
			email: this.state.email,
			department: this.state.department,
			employeeId: this.state.employeeId,
		}
		let that = this;
		axios.put( constants.API_BASE_URL + "user/" + this.state.id,request)
		.then(function (response) {
			that.state.createCB && that.state.createCB(response.data.details);
		})
		.catch(function (error) {
		});
		this.setState({open : false});
	}
	handleInputChange(event) {
		let copiedStates = Object.assign({},this.state);
		copiedStates[event.target.name] = event.target.value;
		console.log('copiedStates handleInputChange',copiedStates);	
		this.setState(
			copiedStates
			);
	}
	render() {
		const { classes } = this.props;
		return(
			<Dialog
			maxWidth={'md'}
			open={this.state.open}
			onClose={this.handleClose}
			TransitionComponent={Transition}
			>
			<DialogTitle>{(this.state.currentAssociate) ? "Edit Associate" : "Add Associate"}</DialogTitle>
			<DialogContent>
			<TextField
			fullWidth
			id="employeeId"
			name="employeeId"
			placeholder="Employee Id"
			label="Employee Id"
			value={this.state.employeeId}
			onChange={this.handleInputChange}
			className={classes.textField}
			margin="normal"
			/>	
			<TextField
			fullWidth
			id="name"
			name="name"
			placeholder="Associate Name"
			label="Associate Name"
			value={this.state.name}
			onChange={this.handleInputChange}
			className={classes.textField}
			margin="normal"
			/>
			<TextField
			id="email"
			fullWidth
			name="email"
			placeholder="Email"
			label="Email"
			value={this.state.email}
			onChange={this.handleInputChange}
			className={classes.textField}
			margin="normal"
			/>
			<TextField
			id="department"
			fullWidth
			name="department"
			placeholder="Department"
			label="Department"
			value={this.state.department}
			onChange={this.handleInputChange}
			className={classes.textField}
			margin="normal"
			/>
			</DialogContent>
			<DialogActions>
			<Button onClick={this.handleClose} color="default">
			Cancel
			</Button>
			{
				(this.state.currentAssociate) ? 
				(
					<Button onClick={this.editAssociates} variant="raised" color="primary">
					Edit
					</Button>
					) : (
					<Button onClick={this.createAssociates} variant="raised" color="primary">
					Add
					</Button>
					)
				}
				</DialogActions>

				</Dialog>
				)
	}
}


WriteAssociate.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WriteAssociate);


// WEBPACK FOOTER //
// ./src/associates/writeAssociate.js